import {SmartComponent} from "smart-component-js";
import LandingUrlBuilder from "../business/LandingUrlBuilder";
import FormUtils from "../common/FormUtils";
import FormBaseComponent from "./FormBaseComponent";

class FormNewsletterComponent extends FormBaseComponent {
    constructor(element, parentComponent, params) {
        params = params || {};
        params.className = "FormNewsletterComponent";
        super(element, parentComponent, params);

        this.$el = $(element);

        this.interval = null;

        //Real inputs
        this.$urlBackField = this.$el.find('[name="redirectURL"]');
        this.$degreeLevel = this.$el.find('[name="Degree_Level__c"]');
        this.$course = this.$el.find('[name="Program_Of_Interest__c"]');
        this.$intake = this.$el.find('[name="School_Term__c"]');
        this.$campus = this.$el.find('[name="CampusLocation__c"]');

        //Constants
        this.formType = this.$el.data('formType');

        this.$degreeLevelField = this.$el.find('#course-type');
        this.$areaField = this.$el.find('#area-input');

        this.allowSubmit = false;

        this.init();
    }

    init() {
        FormUtils.showLoader(this.$el);

        this.interval = setInterval(() => {
            if (this.$el.is(':visible')) {
                clearInterval(this.interval);
                this.imComing();
            }
        }, 500);
    }

    imComing() {
        this.$degreeLevelField.change(() => {
            this.selectedDegreeLevel = this.$degreeLevelField.val();
            this.$degreeLevel.val(this.selectedDegreeLevel);
            if (!!dlKey) {
                this.showCourseSelector();
            }
        });

        this.$el.find('[type="submit"]').click((e) => {
            let checkValidation;
            $("[form-type='newsletter-form'] input[data-required='true']").each(function () {
                switch (this.type) {
                    case 'checkbox':
                        if (!this.checked) {
                            checkValidation = false;
                            return false;
                        } else {
                            checkValidation = true;
                        }
                        break;
                    default:
                        if (!$(this).val()) {
                            checkValidation = false;
                            return false;
                        } else {
                            checkValidation = true;
                        }
                }
            });

            if (true || !this.allowSubmit) {
                e.preventDefault();
                this.allowSubmit = true;

                FormUtils.doCaptcha(e, this.$el, this.$urlBackField, this.formType, () => {
                    setTimeout(() => {
                        checkValidation && $(e.currentTarget).click();
                    }, 200);

                    LandingUrlBuilder.updateUrl(this.$el, this.$urlBackField, this.formType);
                    checkValidation && FormUtils.showLoader(this.$el);
                });
            }

        });
        FormUtils.addFormListeners(this.$el);
        FormUtils.hideLoader(this.$el);

        this.manageNormal();
        this.manageGeneral();
    }
}

export default FormNewsletterComponent;